import { GetServerSidePropsContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { ParsedUrlQuery } from "querystring";
import getChannelConfigByPathName from "src/api/channel";
import { withLayout } from "src/components/Layout/withLayout";
import TermsAndConditions from "src/components/icth-product/terms-and-conditions/TermsAndConditions";
import { LOGICAL_GROUP_CHANNEL_CODE } from "src/constants/logicalGroupChannelCode";

interface TermsAndConditionsPageParams extends ParsedUrlQuery {
  channelPath: string;
}

export async function getServerSideProps(
  context: GetServerSidePropsContext<TermsAndConditionsPageParams>
) {
  const channelPath = context.params?.channelPath;
  const locale = context.locale || "en";
  const channelConfig = await getChannelConfigByPathName(channelPath);

  if (
    !channelConfig ||
    channelConfig.logicalGroupChannelCode !== LOGICAL_GROUP_CHANNEL_CODE
  ) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      channelPath,
      channelConfig,
      isShowAnnouncement: false,
      title: "Terms and Conditions",
      ...(await serverSideTranslations(locale, [
        "common",
        "cookie-consent",
        "layout",
        "terms-and-conditions",
      ])),
    },
  };
}

export default withLayout(TermsAndConditions);
